/**
 * Program Monthly Counts Controller
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @return:   Controller
 */

import angular from 'angular';

angular.module('flsControllers').controller('ProgramSummaryController', [
    '$scope',
    'ProgramSummary',
    function($scope, ProgramSummary){

    /**
     * Loading state
     *
     * @type {Boolean}
     */
    $scope.loading = false;

    /**
     * Define starting data
     *
     * @type {Object}
     */
    $scope.data = {
        headers: [],
        groups:[],
        programs:[],
    }

    /**
     * Define chart options

     * @return Object
     */
    $scope.pieChart = {
        chart: {
            height: 450,
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false
        },
        title: null,
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: true,
                    distance: -50,
                    style: {
                        fontWeight: 'bold',
                        color: 'white'
                    }
                },
                startAngle: -90,
                endAngle: 90,
                center: ['50%', '65%'],
                size: '130%'
            }
        },
        series: [{
            type: 'pie',
            name: 'Browser share',
            innerSize: '50%',
            data: this.chartData
        }]
    };

    /**
     * Init the Controller with the Context Ref string
     *
     * @param  {string} context_ref
     * @return {void}
     */
    $scope.init = function(brand, from = null, to = null) {
        this.load({
            brand: brand || $scope.$parent.brand,
            from : from || $scope.$parent.from,
            to   : to || $scope.$parent.to,
        });
    }

    /**
     * Load the data
     *
     * @param  {object} query
     * @return void
     */
    $scope.load = function(query) {
        /* Enable loader */
        $scope.loading = true;
        /* fetch data */
        ProgramSummary
            .get(query)
            .$promise
            .then(function(response, headers){
                /* Replace the data*/
                $scope.data = response.data;
                /* Assign chart data */
                $scope.chartData = $scope.groupCounts();
                /* Disable loader */
                $scope.loading = false;
            }, function(response, headers){
                _.each(response.data, function(error){
                    $.publish('resource.error', error);
                });
            });
    }

    /**
     * Complet the counts
     *
     * @param  string | array   field
     * @param  string           header
     * @param  string | null    group
     * @return int
     */
    $scope.headcount = function(field, header, statusGroup = null, count = 0) {

        _.castArray(field).forEach(field => {
            count += _.sumBy(this.programs(header, statusGroup), field);
        });

        return count;
    }

    /**
     * Access programs as method
     *
     * @param  string           header
     * @param  string | null    group
     * @return collection
     */
    $scope.programs = function(header = null, statusGroup = null) {
        /* Chain the values */
        return _.chain(this.data.programs)
                /* filter by header value, must be exact match */
                .filter((program)=>{
                    return _.isNull(header) || _.isEqual(program.aggregateGroup, header);
                })
                /* filter by group value, must be exact match */
                .filter((program)=>{
                    return _.isNull(statusGroup) || _.isEqual(program.aggregateStatusGroup, statusGroup);
                })
                .value();
    }

    /**
     * Group the data for the charts
     *
     * @return {collection}
     */
    $scope.groupCounts = function() {
        let all = [];

        _.forEach(this.data.groups, group => {
            all.push([group, this.programs(null, group).length]);
        })

        return all;
    }
}]);
